export const errorMessage = (errors) => {
    return (
        <div className="text-red-600 text-sm whitespace-normal p-3 text-center">{errors.map((error) => error)}</div>
    )
}
